// extracted by mini-css-extract-plugin
export var border = "_28-8";
export var brand = "_28-t";
export var button = "_28-l";
export var center = "_28-a";
export var centered = "_28-6";
export var closeButton = "_28-c";
export var disabledWrapper = "_28-m";
export var error = "_28-p";
export var extraLarge = "_28-4";
export var extraSmall = "_28-1";
export var fill = "_28-i";
export var footer = "_28-h";
export var footerAction = "_28-j";
export var footerButtons = "_28-k";
export var header = "_28-7";
export var headerWithClose = "_28-d";
export var icon = "_28-o";
export var info = "_28-s";
export var inline = "_28-9";
export var large = "_28-3";
export var main = "_28-e";
export var modal = "_28-0";
export var nearFull = "_28-5";
export var neutral = "_28-u";
export var noPadding = "_28-g";
export var none = "_28-v";
export var scrollable = "_28-f";
export var small = "_28-2";
export var success = "_28-r";
export var tight = "_28-n";
export var titleIcon = "_28-b";
export var warn = "_28-q";